// No dedicated backend permission exists yet for this feature — reuses the
// same permission keys as the rest of the Clientes module (CLIENTS_PERMISSIONS)
// so the menu item and actions actually render for the roles that already
// manage clients. Swap these for real BUSINESS_ACCOUNT_REQUEST_* keys once
// the backend defines them.
export enum BUSINESS_ACCOUNT_REQUEST_PERMISSIONS {
  BUSINESS_ACCOUNT_REQUEST_VIEW = 'CRM_USER_VIEW',
  BUSINESS_ACCOUNT_REQUEST_WRITE = 'USER_ADMINWRITE',
}
